import { createApp } from 'vue'
import store from './store'
import router from './router'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import './Authentication'
import axios from 'axios'

// patch axios to always include credentials when sending requests
axios.defaults.withCredentials = true;

// patch BigInt to always serialize to string when converting BigInt to JSON
(BigInt.prototype as any).toJSON = function () {
  return this.toString();
};

loadFonts()

// set up and mount the app
const app = createApp(App)
app.use(store)      // reactive store via Pinia
app.use(router)     // where routes are defined
app.use(vuetify)    // get Vuetify UI components
app.mount('#app')
